module.exports = __webpack_public_path__ + "img/tree.3ba6fbcf.png";